/* eslint-disable default-case */

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
export const initialState = {
  basket: [],
  user: null,
  detail: [],
  blog: [],
  totalPrice: 0,
  totalQty: 0,
};

const reducer = (state, action) => {
  const { basket } = state;

  console.log(action);
  switch (action.type) {
    case "ADD_TO_BASKET":

        toast.success('Added to cart successfully', {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        });
        
      return {
        ...state,
        basket: [...state.basket, action.item],
      };


    case "PRODUCT_DETAILS":
      return {
        ...state,
        detail: [action.item],
      };

    case "BLOG_CARD":
      return {
        ...state,
        blog: [action.item],
      };

    case "SET_LOGIN":
      return {
        ...state,
        user: action.user,
      };

    case "EMPTY_BASKET":
      return {
        ...state,
        basket: [],
      };

    case "REMOVE_FROM_CART":
      let newcart = [...state.basket];
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.id
      );
      if (index >= 0) {
        newcart.splice(index, 1);
      } else {
        console.log(
          "There were error while removing the product from the cart"
        );
      }
      return {
        ...state,
        basket: newcart,
      };
  }
};

export default reducer;
